import { ChevronDown, Compass, LogOut, Settings, Trophy } from 'lucide-react';
import { AdminIcon, PersonIcon as UserIcon } from '@/shared/config';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Avatar,
  Menu,
  MenuContent,
  MenuGroup,
  MenuGroupLabel,
  MenuItem,
  MenuSeparator,
  MenuTrigger,
} from '@/shared/ui';
import { useAuthStore } from '../model/auth-store';
import { useAdminAccess } from '../model/use-admin-access';
import { keycloakLogout } from '../model/init-keycloak';
import { tourFor, useTourStore } from '@/features/onboarding-tour';
import styles from './UserMenu.module.css';

export const UserMenu: React.FC = () => {
  const user = useAuthStore((s) => s.user);
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const isStaff = hasPermission('view_tickets');
  const { canAccess: canAccessAdmin } = useAdminAccess();
  const [tourRequested, setTourRequested] = useState(false);
  if (!user) return null;

  return (
    <Menu
      onOpenChangeComplete={(open) => {
        if (open || !tourRequested) return;
        setTourRequested(false);
        useTourStore.getState().start(tourFor(hasPermission), true);
      }}
    >
      <MenuTrigger className={styles.trigger} aria-label="Меню пользователя">
        <Avatar
          className={styles.avatar}
          name={user.name || user.email}
          seed={user.id}
          src={user.avatarUrl}
          aria-hidden
        />
        <span>{user.name || user.email}</span>
        <ChevronDown size={16} aria-hidden className={styles.chevron} />
      </MenuTrigger>
      <MenuContent align="end" sideOffset={8} className={styles.content}>
        <MenuGroup>
          <MenuGroupLabel className={styles.userInfo}>{user.email}</MenuGroupLabel>
          <MenuItem render={<Link to="/users/me" />}>
            <UserIcon size={15} aria-hidden />
            Мой профиль
          </MenuItem>
          <MenuItem render={<Link to="/settings" />}>
            <Settings size={15} aria-hidden />
            Настройки
          </MenuItem>
          {isStaff && (
            <MenuItem render={<Link to="/kpi" />}>
              <Trophy size={15} aria-hidden />
              KPI
            </MenuItem>
          )}
          {canAccessAdmin && (
            <MenuItem render={<Link to="/admin" />}>
              <AdminIcon size={15} aria-hidden />
              Администрирование
            </MenuItem>
          )}
          { }
          <MenuItem onClick={() => setTourRequested(true)}>
            <Compass size={15} aria-hidden />
            Экскурсия по порталу
          </MenuItem>
        </MenuGroup>
        <MenuSeparator />
        <MenuItem variant="danger" onClick={() => keycloakLogout()}>
          <LogOut size={15} aria-hidden />
          Выйти
        </MenuItem>
      </MenuContent>
    </Menu>
  );
};
